import React from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";

const Count = () => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const answeringInfo = useSelector( state => state.answeringInfo );

  return (
    <div className="qa-cnt-wrap">
      <span className="num">{ answeringQuestions.answeringCount }</span>
      <span>/</span>
      <span className={ clsx( 'num-tot', answeringInfo.questionCountAccentClassName ) }>{ answeringQuestions.data.totQstCt }</span>
    </div>
  );

};

export default Count;
